export const TECHNICAL = 'txn_exp_downpayment_technical_a';
export const FRIENDLY = 'txn_exp_downpayment_friendly_b';
export const SHORT_CONTENT = 'txn_exp_downpayment_content_short_c';
export const CONTROL_GROUP = 'txn_exp_downpayment_control_group';
export const APPLICATION_REFERRER = 'referrer';
export const USER_IN_ARREARS_REASON = 'user_in_arrears';
